import styled, { keyframes } from 'styled-components'
import { Section, Container } from './UserHomePage.styles'

/* ================= ANIMATION ================= */
/**
 * Vì clone text 3 lần → chạy -33.333% để loop mượt
 */
const marquee = keyframes`
   0% {
      transform: translateX(0);
   }
   100% {
      transform: translateX(-33.333%);
   }
`

/* ================= STYLES ================= */

const PromotionSection = styled(Section)`
   background: #edbb1d;
   padding: 8px 0;
`

const BannerInner = styled.div`
   display: flex;
   align-items: center;
   gap: 16px;
`

const MarqueeWrapper = styled.div`
   flex: 1;
   overflow: hidden;
   white-space: nowrap;
   width: 100%;
`

const MarqueeTrack = styled.div`
   display: flex;
   width: fit-content;
   animation: ${marquee} 45s linear infinite;

   @media (max-width: 768px) {
      animation-duration: 60s;
   }
`

const MarqueeItem = styled.div`
   flex-shrink: 0;
   white-space: nowrap;
   padding-right: 50px; /* 👈 khoảng cách đẹp như yêu cầu */

   font-size: 18px;
   font-weight: 500;
   color: #000;

   @media (max-width: 768px) {
      font-size: 14px;
   }
`

const InstallLink = styled.a`
   flex-shrink: 0;
   padding: 6px 14px;
   border-radius: 20px;
   background: #000;
   color: #edbb1d;
   font-size: 14px;
   font-weight: 500;
   text-decoration: none;
   white-space: nowrap;
   cursor: pointer;
   transition: all 0.2s ease;

   &:hover {
      background: #111;
      color: #fff;
   }
`

/* ================= COMPONENT ================= */

const PromotionBanner = () => {
   const scrollTo = (id: string) => {
      const el = document.getElementById(id)
      if (el) {
         el.scrollIntoView({ behavior: 'smooth' })
      }
   }

   const text = (
      <>
         🎉 Chào mừng ra mắt ứng dụng <b>Xe ghép Thanh Hóa – Hà Nội</b> trên iOS & Android – Tải app ngay hôm nay để
         nhận ưu đãi giảm giá cực hấp dẫn 🎉
      </>
   )

   return (
      <PromotionSection id="promotion">
         <Container>
            <BannerInner>
               {/* ===== MARQUEE TEXT ===== */}
               <MarqueeWrapper>
                  <MarqueeTrack>
                     <MarqueeItem>{text}</MarqueeItem>
                     <MarqueeItem>{text}</MarqueeItem>
                     <MarqueeItem>{text}</MarqueeItem>
                  </MarqueeTrack>
               </MarqueeWrapper>

               {/* ===== FIXED CTA ===== */}
               <InstallLink onClick={() => scrollTo('download')}>📲 Cài app ngay</InstallLink>
            </BannerInner>
         </Container>
      </PromotionSection>
   )
}

export default PromotionBanner
